import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Landing } from '@/pages/Landing'
import SignUp from '@/pages/auth/SignUp'
import SignIn from '@/pages/auth/SignIn'
import ForgotPassword from '@/pages/auth/ForgotPassword'
import ResetPassword from '@/pages/auth/ResetPassword'
import Dashboard from '@/pages/Dashboard'
import ManageVisits from '@/pages/manage/Visits'
import ManageProperties from '@/pages/manage/Properties'
import ManageMembership from '@/pages/manage/Membership'
import ManageDocuments from '@/pages/manage/Documents'
import ActiveVisit from '@/pages/manage/ActiveVisit'
import Profile from '@/pages/Profile'
import Refer from '@/pages/Refer'
import Notifications from '@/pages/Notifications'
import Settings from '@/pages/Settings'

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/manage/visits" element={<ManageVisits />} />
        <Route path="/manage/properties" element={<ManageProperties />} />
        <Route path="/manage/membership" element={<ManageMembership />} />
        <Route path="/manage/documents" element={<ManageDocuments />} />
        <Route path="/manage/active-visit" element={<ActiveVisit />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/refer" element={<Refer />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </BrowserRouter>
  )
}
